
import {Injectable} from "@angular/core";
import {ILocalStorage} from "./ILocalStorage";

@Injectable()
export class LocalStorage implements ILocalStorage{

    Get(key: string): string {
        return localStorage.getItem(key);
    }

    Set(key: string, value: string): void {
        localStorage.setItem(key, value);
    }

    Remove(key: string): void {
        localStorage.removeItem(key);
    }

    Exists(key: string): boolean {
        return localStorage.getItem(key) != null;
    }
}



// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/privacy-policy/LocalStorage.ts